import React, { useMemo, useState } from "react";
import { Breadcrumb, Button, Select, Space, Table, Tooltip } from "antd";
import { Link, useLocation } from "react-router-dom";

import "../../../styles/Main.scss";

const DEFAULT_STATE = {
  verificationRef: "#VER-GOTA-NOV25",
  totalItems: 150,
  mismatches: 4,
  varianceRows: [
    {
      key: "ITEM-TAP-001",
      item: "Basin Mixer Tap",
      expected: 10,
      physical: 9,
      variance: -1,
      userNotes: "One unit missing behind rack.",
    },
    {
      key: "ITEM-CEM-050",
      item: "Paint Bucket 20L White",
      expected: 20,
      physical: 22,
      variance: 2,
      userNotes: "Extra bucket found, no PO tag.",
    },
    {
      key: "ITEM-PVC-2IN",
      item: "PVC Pipe 2 inch",
      expected: 65,
      physical: 60,
      variance: -5,
      userNotes: "Shortage observed at site store.",
    },
    {
      key: "ITEM-WIRE-12",
      item: "Electrical Wire 12 AWG",
      expected: 200,
      physical: 205,
      variance: 5,
      userNotes: "Additional coil found in storage area.",
    },
  ],
};

const PhysicalMaterialVarianceSummary = () => {
  const location = useLocation();
  const navState = location.state || DEFAULT_STATE;

  const [filter, setFilter] = useState("All");

  const filteredRows = useMemo(() => {
    if (filter === "Shortage Only") {
      return (navState.varianceRows || []).filter((r) => r.variance < 0);
    }
    if (filter === "Excess Only") {
      return (navState.varianceRows || []).filter((r) => r.variance > 0);
    }
    return navState.varianceRows || [];
  }, [filter, navState.varianceRows]);

  const columns = [
    { title: "Item", dataIndex: "item", key: "item" },
    { title: "Expected", dataIndex: "expected", key: "expected", width: 120, align: "right" },
    { title: "Physical", dataIndex: "physical", key: "physical", width: 120, align: "right" },
    {
      title: "Variance",
      dataIndex: "variance",
      key: "variance",
      width: 140,
      align: "right",
      render: (value) => (
        <span className={value < 0 ? "text-danger" : value > 0 ? "text-success" : ""}>
          {value > 0 ? `+${value}` : value}
        </span>
      ),
    },
    { title: "User Notes", dataIndex: "userNotes", key: "userNotes" },
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip title="Summary of discrepancies found during physical inventory verification">
              <h3>Variance Summary Report</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Material Indent</Breadcrumb.Item>
              <Breadcrumb.Item>Variance Summary</Breadcrumb.Item>
            </Breadcrumb>
            
          </div>
        </div>
      </div>

      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <div className="po-good-header">
          <div className="po-header-details" style={{ margin: "0" }}>
              <div className="po-row">
                <strong>{navState.verificationRef}</strong>
              </div>
              <div className="po-row">
                <strong>Total Items:</strong>
                <span>{navState.totalItems}</span>
              </div>
              <div className="po-row">
                <strong>Mismatches:{" "}</strong>
                <span>{navState.mismatches}</span>
              </div>
            </div>
            <Space wrap size={10}>
              <div className="table-title mb-0">Filter by Discrepancies</div>
              <Select
                value={filter}
                onChange={setFilter}
                style={{ width: 220 }}
                options={[
                  { label: "All", value: "All" },
                  { label: "Shortage Only", value: "Shortage Only" },
                  { label: "Excess Only", value: "Excess Only" },
                ]}
              />
            </Space>
          </div>

          <div className="tablewrp">
            <Table
              rowKey="key"
              columns={columns}
              dataSource={filteredRows}
              pagination={false}
              scroll={{ x: 900 }}
            />
          </div>

          <div className="FormFooter" style={{paddingRight:'0',paddingLeft:'0', marginBottom:'0'}}>
            <div />
            <Button
              type="primary"
              className="SaveGradiantBtn"
              onClick={() => {
                // eslint-disable-next-line no-console
                console.log("Export Report & Request Adjustment", {
                  verificationRef: navState.verificationRef,
                  filter,
                  rows: filteredRows,
                });
              }}
            >
              Export Report &amp; Request Adjustment
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default PhysicalMaterialVarianceSummary;